import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Simplifyte",
  description = "One workspace to assign, approve, and close work - without follow-up chaos.",
  keywords = "workspace management, task management, team collaboration, document management, CA firms software, legal team tools, IT service management, SaaS productivity, workflow automation, Simplifyte",
  image = "https://www.simplifyte.com/preview.jpg",
  url = "https://www.simplifyte.com",
  type = "website",
  publishedTime,
  author = "Simplifyte",
  noindex = false,
}) => {
  const siteTitle = title.includes("Simplifyte")
    ? title
    : `${title} | Simplifyte`;

  // console.log("3232", image);

  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>{siteTitle}</title>
        {/* {console.log("3232 description", description)} */}
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content={type} />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content="Simplifyte" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />

        {/* Canonical URL */}
        <link rel="canonical" href={url} />

        {/* Article published time if applicable */}
        {publishedTime && (
          <meta property="article:published_time" content={publishedTime} />
        )}

        {/* Noindex if needed */}
        {noindex && <meta name="robots" content="noindex" />}
      </Helmet>
    </>
  );
};

export default SEO;
